import React from "react";
import GiropayIcon from '../../../assets/svg/giropay.svg';
import FrameBlockResult from '../FrameBlockResult'
import { ApmsTypes } from "../../../constants";

const GiroPayResult = ({ link }) => {
    return (
        <FrameBlockResult link={link} apmType={ApmsTypes.Giropay} icon={GiropayIcon} />
    )
}

export default GiroPayResult;